//Permanent
const twitterAccount = "elcomercio_peru";    
const brand = "El Comercio";
const urlBrand = "https://elcomercio.pe";
const urlPortadaEspeciales = "https://especiales.elcomercio.pe/?q=especiales/especiales-el-comercio/index.html";
const domainMarca = "https://especiales.elcomercio.pe/?q=especiales/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/';
const slugCommonAssets2 = 'elementos-comunes-2/';

//Variables
const titleEspecial = 'Premios DT 2021';
const socialShareText = "Premios DT 2021 | El Comercio";
const slugEspecial = "premios-dt-2021-multimedia-nndd-ecvisual-ecpm";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlEspecialVideos = `${domainMarca}${slugEspecial}`;
const urlAssets = `${domainAssets}${slugEspecial}`;
const urlCommonAssets = `${domainAssets}${slugCommonAssets2}`;
const queryStrStart = '&';
const queryStrSndParam = '&';
const urlJson = `${domainAssets}${slugEspecial}/json/winnersv2.json`;
//const urlJson = 'http://localhost:81/especiales/premios-dt-2021-multimedia-nndd-ecvisual-ecpm/json/winnersv2.json';
const queryStrCategory = 'categoria';
const queryStrWinner = 'ganador';
const slugLiga1 = 'liga-1';
const slugPolideportivo = 'polideportivo';

export { 
    brand,
    domainAssets, 
    domainMarca, 
    queryStrStart, 
    queryStrSndParam,
    queryStrCategory,
    queryStrWinner,
    slugEspecial, 
    slugLiga1,
    slugPolideportivo,
    socialShareText, 
    titleEspecial, 
    twitterAccount, 
    urlCommonAssets,
    urlBrand, 
    urlPortadaEspeciales,    
    urlAssets, 
    urlEspecial, 
    urlEspecialVideos,
    urlJson    
}